import React from 'react';
import { CheckCircle, Shield, Workflow } from 'lucide-react';

const BetterWaySection = () => {
  const benefits = [
    { icon: Workflow, text: "No change to operations" },
    { icon: Shield, text: "No upfront cost" },
    { icon: CheckCircle, text: "Works with your current workflow" }
  ];

  return (
    <section className="py-16" style={{ backgroundColor: '#F8FAFC' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-8">
          <span style={{ color: '#0F172A' }}>There's a Better, </span>
          <span style={{ color: '#22C55E' }}>Compliant Way</span>
        </h2>
        
        <div className="flex flex-col md:flex-row justify-center gap-6">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <div 
                key={index}
                className="flex items-center gap-3 bg-white rounded-xl px-6 py-4 shadow-lg border border-gray-100"
                data-testid={`benefit-${index}`}
              >
                <div 
                  className="w-10 h-10 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(34, 197, 94, 0.1)' }}
                >
                  <IconComponent style={{ color: '#22C55E' }} size={20} />
                </div>
                <span className="font-semibold" style={{ color: '#0F172A' }}>{benefit.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BetterWaySection;
